import styled from "@emotion/styled";

const Wrapper = styled.div`
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  align-items: center;
  min-width: 69px;
  border-radius: 7px;

  padding: 6px ${p => p.theme.space[3]}px;

  background-color: ${p => p.theme.colors.white};

  position: relative;
  color: ${p => p.theme.colors.secondary.main};
  font-size: ${p => p.theme.space[5]}px;
  cursor: pointer;
  vertical-align: middle;
  transition:
    outline-color 0.3s ease,
    color 0.3s ease;
  outline: ${p => p.theme.space[1]}px solid transparent;

  &:hover,
  &:focus {
    outline-color: ${p => p.theme.colors.accent.green};
  }

  @media (min-width: ${p => p.theme.screenSizes.mdMin}) {
    min-width: 89px;
    padding: ${p => p.theme.space[4]}px ${p => p.theme.space[5]}px;
  }
`;

const Lang = styled.p`
  align-items: center;
  text-transform: capitalize;
  display: flex;
  margin: 0;
  justify-content: space-between;
  color: ${p => p.theme.colors.black};
`;

const BoxArrow = styled.div`
  position: relative;

  &::before {
    content: url("/assets/svg/arrowDecor.svg");
    position: absolute;
    top: -14px;
    right: 6%;

    @media (min-width: ${p => p.theme.screenSizes.mdMin}) {
      right: 13%;
    }

    display: ${p => (p.location === "base" ? "block" : "none")};
  }
`;

export { Wrapper, Lang, BoxArrow };
